import React, { Fragment, useState } from "react"

export const RateTag = () => {
  return (
    <div className="rate-tag">
      <span>Top rated</span>
    </div>
  )
}